import { createContext, useContext } from "react";
export const DATA_TABLE_DENSITIES = ["compact", "default", "relaxed"];
/** Row height per density, in px. `default` is the historical 48px row. */
export const DATA_TABLE_ROW_HEIGHT_PX = {
  compact: 40,
  default: 48,
  relaxed: 64
};
export const DENSITY_ROW_HEIGHT_CLASS = {
  compact: "h-10",
  default: "h-12",
  relaxed: "h-16"
};
export const DATA_TABLE_HEADER_HEIGHT_PX = DATA_TABLE_ROW_HEIGHT_PX;
export const DENSITY_HEADER_HEIGHT_CLASS = DENSITY_ROW_HEIGHT_CLASS;

// 124px column minimum when scrolling horizontally, so columns stay readable.
export const SCROLL_COLUMN_MIN_WIDTH_CLASS = "min-w-31";
export const DEFAULT_DATA_TABLE_LAYOUT = {
  density: "default",
  enforceColumnMinWidth: false
};

// Lets cell helpers follow the table's density and scroll layout without call
// sites threading props through column defs.
export const DataTableLayoutContext = createContext(DEFAULT_DATA_TABLE_LAYOUT);
export function useDataTableLayout() {
  return useContext(DataTableLayoutContext);
}
//# sourceMappingURL=layout.js.map